export default [
  {
    game_name: "邪瞳专属单职业",
    ip: "180版版",
    type: "8月10日/11点开放",
    line: "新职业丰富玩法",
    detail: "职业丰富长久耐玩追梦★ -推荐",
    qq: "灬纯PC推",
    game_id: "3800097",
    plan: "A",
  },
  {
    game_name: "黄泉火龙大极品▃",
    ip: "长久火龙专属★",
    type: "8月10日/11点开放",
    line: "※上线领礼爽",
    detail: "━上线领礼双号开荒多图打宝燃★",
    qq: "※火龙打宝追梦服",
    game_id: "3800096",
    plan: "A",
  },
  {
    game_name: "道观复古沉默",
    ip: "灬沉默★专属",
    type: "8月10日/11点开放",
    line: "█全新等级好升",
    detail: "等级好升多◆图打宝打金服",
    qq: "沉默专属▃",
    game_id: "3800109",
    plan: "A",
  },
  {
    game_name: "文狸墨竹特戒▃",
    ip: "爆经█典复古〃",
    type: "8月10日/11点开放",
    line: "新区连开稳",
    detail: "新区连开散人友好多图打宝散人必玩▃",
    qq: "复古怀◆旧散人服",
    game_id: "3800053",
    plan: "A",
  },
  {
    game_name: "纯PC小呆瓜破坏神╊",
    ip: "※长久特色传奇",
    type: "8月10日/11点开放",
    line: "◆特色·玩法",
    detail: "▁特色玩法经典耐玩冲▃",
    qq: "纯PC※推玩法╊",
    game_id: "3800002",
    plan: "A",
  },
  {
    game_name: "琴台神◆器专属",
    ip: "▲真神器专属◆",
    type: "8月10日/11点开放",
    line: "装备回收爆▃",
    detail: "灬装备回收等级好升多图打宝长期真耐玩",
    qq: "神器追※梦玩法╊",
    game_id: "3800086",
    plan: "A",
  },
  {
    game_name: "◆霁月火·龙单职业",
    ip: "※火龙专属",
    type: "8月10日/11点开放",
    line: "新区连开首战区★",
    detail: "新区连开长久耐玩装备靠打╊",
    qq: "※火龙打宝爽",
    game_id: "3800088",
    plan: "A",
  },
  {
    game_name: "朱砂战神三职业",
    ip: "180版可搬砖",
    type: "8月10日/11点开放",
    line: "长久散人友好▃",
    detail: "※散人友好无坑公平神宠助战冲",
    qq: "复古怀旧▃",
    game_id: "3800101",
    plan: "A",
  },
  {
    game_name: "※裂空神器专属",
    ip: "神器专属╊",
    type: "8月10日/11点开放",
    line: "爆率全开新区",
    detail: "爆率全开无█坑公平追梦〃",
    qq: "◆神器·追梦",
    game_id: "3800094",
    plan: "A",
  },
  {
    game_name: "█怒雷天之冰雪",
    ip: "※长久冰雪复古",
    type: "8月10日/11点开放",
    line: "█新区连开区",
    detail: "新区连开特◆色玩法首战区",
    qq: "▁纯PC推真耐玩",
    game_id: "3800075",
    plan: "A",
  },
  {
    game_name: "█归鸦沉默单职业",
    ip: "新沉█默单职〃",
    type: "8月10日/11点开放",
    line: "职业丰富爽▃",
    detail: "职业丰富长久耐玩专属神器新区首战",
    qq: "※沉默专属首战区",
    game_id: "3800092",
    plan: "A",
  },
  {
    game_name: "沉默华夏▃",
    ip: "◆沉默·专属",
    type: "8月10日/11点开放",
    line: "经典特◆色玩法",
    detail: "※特色玩法经典耐玩热血开荒·",
    qq: "▁沉默专属",
    game_id: "111661",
    plan: "A",
  },
  {
    game_name: "◆书斋迷·失神器",
    ip: "经典神器专属系统",
    type: "8月10日/11点开放",
    line: "※装备靠打玩法·",
    detail: "※装备靠打无坑公平多图打宝燃",
    qq: "灬神器追梦爆",
    game_id: "3800105",
    plan: "A",
  },
  {
    game_name: "▁刀域神器专属▃",
    ip: "◆神器·专属",
    type: "8月10日/11点开放",
    line: "长久多图打宝★",
    detail: "※多图打宝零氪畅玩打金服·",
    qq: "神器追梦★",
    game_id: "3800102",
    plan: "A",
  },
  {
    game_name: "灬玄策沉★默专属",
    ip: "▁沉默三职",
    type: "8月10日/11点开放",
    line: "新区连※开玩法╊",
    detail: "新区连开泡点升级开战",
    qq: "沉默专属爆★",
    game_id: "3800049",
    plan: "A",
  },
  {
    game_name: "酒庐传奇1★",
    ip: "新特█色传奇〃",
    type: "8月10日/11点开放",
    line: "特色玩法散人首选",
    detail: "━特色玩法经典耐玩爽★",
    qq: "※纯PC推模式·",
    game_id: "3800107",
    plan: "A",
  },
  {
    game_name: "灬血池攻速无限刀",
    ip: "180版玩法",
    type: "8月10日/11点开放",
    line: "长久多图打宝▃",
    detail: "※多图打宝魔王高爆打金服·",
    qq: "█神器追梦",
    game_id: "3800095",
    plan: "A",
  },
  {
    game_name: "※刀域火龙",
    ip: "火龙专属★",
    type: "8月10日/11点开放",
    line: "装备回收必体验╊",
    detail: "灬装备回收首爆奖励职业丰富散人来追梦",
    qq: "神器追梦爽▃",
    game_id: "3800081",
    plan: "A",
  },
  {
    game_name: "无定赤月大极品",
    ip: "▲真特色传奇◆",
    type: "8月10日/11点开放",
    line: "新区连开首战区",
    detail: "新区连开散◆人友好散人服",
    qq: "█散人推荐可搬砖",
    game_id: "3800080",
    plan: "A",
  },
  {
    game_name: "※霁月攻速单职业",
    ip: "神器专属首战区〃",
    type: "8月10日/11点开放",
    line: "职业丰富╊",
    detail: "职业丰富散人友好必玩",
    qq: "经典神器追梦〃",
    game_id: "3800054",
    plan: "A",
  },
  {
    game_name: "灬墨染微变单职业",
    ip: "▁特色单职区",
    type: "8月10日/11点开放",
    line: "长久长久耐玩★",
    detail: "▁长久耐玩等级好升多图打宝首战区",
    qq: "※散人推荐",
    game_id: "3800078",
    plan: "A",
  },
  {
    game_name: "墨杀攻速单职业▃",
    ip: "▁特色单职必体验",
    type: "8月10日/11点开放",
    line: "※长久耐玩",
    detail: "◆长久耐玩装·备靠打刚开服",
    qq: "█全新攻速推荐",
    game_id: "3800045",
    plan: "A",
  },
  {
    game_name: "素霓传奇2▃",
    ip: "灬特色★传奇",
    type: "8月10日/11点开放",
    line: "长久特色玩法▃",
    detail: "特色玩法经典耐玩热血开荒追梦",
    qq: "纯PC推★",
    game_id: "3800104",
    plan: "A",
  },
  {
    game_name: "灬断猿摸金传奇",
    ip: "176版玩法",
    type: "8月10日/11点开放",
    line: "魔王◆高爆",
    detail: "魔王高爆切割狂暴散人友好长久耐玩▃",
    qq: "爆复█古怀旧〃",
    game_id: "3800093",
    plan: "A",
  },
  {
    game_name: "※禅院传奇1",
    ip: "特色传奇〃",
    type: "8月10日/11点开放",
    line: "▁特色玩法追梦服",
    detail: "※特色玩法经典耐玩热血开荒冲",
    qq: "灬纯★PC推",
    game_id: "3800108",
    plan: "A",
  },
  {
    game_name: "灬暮雪沉★默三职业",
    ip: "灬沉默三职",
    type: "8月10日/11点开放",
    line: "多图打宝追梦服〃",
    detail: "※多图打宝等级好升装备回收爆",
    qq: "※沉默专属爆",
    game_id: "3800090",
    plan: "A",
  },
  {
    game_name: "残照狂█徒迷失〃",
    ip: "特色传奇爽",
    type: "8月10日/11点开放",
    line: "新切割狂暴",
    detail: "切割狂暴等级好升神宠助战",
    qq: "▲真高爆推荐◆",
    game_id: "3800089",
    plan: "A",
  },
  {
    game_name: "书斋沉默专属",
    ip: "爆沉默专属专服",
    type: "8月10日/11点开放",
    line: "灬泡点升级真耐玩",
    detail: "※泡点升级多图打宝职业丰富爽",
    qq: "沉默专属稳〃",
    game_id: "3800110",
    plan: "A",
  },
  {
    game_name: "灬无常专★属神器",
    ip: "长久无限刀版专服",
    type: "8月10日/11点开放",
    line: "▁首爆奖励首战区",
    detail: "首爆奖励装备回收多图打宝开战〃",
    qq: "神器追梦",
    game_id: "3800100",
    plan: "A",
  },
  {
    game_name: "未休魅影骷髅王",
    ip: "特色传奇真耐玩〃",
    type: "8月10日/11点开放",
    line: "新区◆连开",
    detail: "新区连开无坑公平长久耐玩╊",
    qq: "经典纯◆PC推",
    game_id: "3800057",
    plan: "A",
  },
  {
    game_name: "踵武仙剑沉默",
    ip: "※沉默专属首战区",
    type: "8月10日/11点开放",
    line: "新区连开╊",
    detail: "◆新区连开·泡点升级",
    qq: "长久沉默专属▃",
    game_id: "3800060",
    plan: "A",
  },
  {
    game_name: "钜峰复古沉默★",
    ip: "沉默专属散人服★",
    type: "8月10日/11点开放",
    line: "※新区连开",
    detail: "新区连开长久耐玩上线领礼╊",
    qq: "新沉█默专属〃",
    game_id: "3800050",
    plan: "A",
  },
  {
    game_name: "衍月灵猫传奇",
    ip: "全新176版╊",
    type: "8月10日/11点开放",
    line: "灬新区★连开",
    detail: "新区连开职业丰富开战★",
    qq: "复古怀旧",
    game_id: "3800052",
    plan: "A",
  },
  {
    game_name: "枯荷高爆神器▃",
    ip: "█神器专属爽",
    type: "8月10日/11点开放",
    line: "新装备靠打模式",
    detail: "装备靠打多◆图打宝打金服",
    qq: "█神器追梦",
    game_id: "3800056",
    plan: "A",
  },
  {
    game_name: "啼鹃变速狂刀",
    ip: "185版追梦服★",
    type: "8月10日/11点开放",
    line: "真激情攻沙",
    detail: "激情攻沙零氪畅玩多图打宝首战区",
    qq: "全新纯PC推╊",
    game_id: "3800062",
    plan: "A",
  },
  {
    game_name: "※归鸦无限刀·",
    ip: "长久无限刀版▃",
    type: "8月10日/11点开放",
    line: "货币可打爽╊",
    detail: "█货币可打上线领礼冲",
    qq: "攻速推荐真耐玩★",
    game_id: "3800059",
    plan: "A",
  },
  {
    game_name: "画舫微◆变三职业",
    ip: "180版模式",
    type: "8月10日/11点开放",
    line: "专属神器╊",
    detail: "专属神器职◆业丰富散人服",
    qq: "新神█器追梦〃",
    game_id: "3800106",
    plan: "A",
  },
  {
    game_name: "琴台攻※速无限刀╊",
    ip: "真无限刀版系统",
    type: "8月10日/11点开放",
    line: "※专属神器爽",
    detail: "专属神器多图打宝首战区",
    qq: "※沉默专属模式·",
    game_id: "3800103",
    plan: "A",
  },
  {
    game_name: "▲墨染微变三职业◆",
    ip: "※经典三职首战区",
    type: "8月10日/11点开放",
    line: "爆率全开▃",
    detail: "爆率全开无◆坑公平散人服",
    qq: "爆高爆推荐新区",
    game_id: "3800099",
    plan: "A",
  },
  {
    game_name: "━裂空合击★",
    ip: "经典合击首战区",
    type: "8月10日/11点开放",
    line: "经典多图打宝",
    detail: "多图打宝装备保※值特色玩法必玩╊",
    qq: "合击推荐",
    game_id: "3800066",
    plan: "A",
  },
  {
    game_name: "※百破灵猫沉默",
    ip: "█沉默专属爽",
    type: "8月10日/11点开放",
    line: "全新新区连开╊",
    detail: "灬新区连开多图打宝特色玩法长期真耐玩",
    qq: "沉默专属〃",
    game_id: "3800068",
    plan: "A",
  },
  {
    game_name: "无常沉◆默三职业",
    ip: "长久沉默三职玩法",
    type: "8月10日/11点开放",
    line: "新区连◆开追梦服",
    detail: "新区连开长◆久耐玩长久服",
    qq: "灬沉默★专属",
    game_id: "3800074",
    plan: "A",
  },
  {
    game_name: "刀藏诛仙专属",
    ip: "经典火龙专属〃",
    type: "8月10日/11点开放",
    line: "灬新区连开爆",
    detail: "灬新区连开装备回收多图打宝长期真耐玩",
    qq: "火龙打宝新区",
    game_id: "3800048",
    plan: "A",
  },
  {
    game_name: "霜雪鲁王传奇▃",
    ip: "灬特色传奇追梦服",
    type: "8月10日/11点开放",
    line: "▁新区连开",
    detail: "灬新区连开散人★友好多图打宝爽",
    qq: "经典散人推荐",
    game_id: "3800065",
    plan: "A",
  },
  {
    game_name: "暮雪渝乐复古",
    ip: "神器专◆属追梦服",
    type: "8月10日/11点开放",
    line: "█长久耐玩",
    detail: "灬长久耐玩装备靠打★等级好升激情开荒",
    qq: "▲真复古怀旧◆",
    game_id: "3800058",
    plan: "A",
  },
  {
    game_name: "枯荷180小极品〃",
    ip: "180※版玩法╊",
    type: "8月10日/11点开放",
    line: "装备◆保值",
    detail: "装备保值装备回收泡点升级╊",
    qq: "灬经典散人推荐",
    game_id: "3800091",
    plan: "A",
  },
  {
    game_name: "素霓战神三职业",
    ip: "经典经典三职",
    type: "8月10日/11点开放",
    line: "◆泡点·升级",
    detail: "※泡点升级神宠助战多图打宝燃",
    qq: "散人推◆荐可搬砖",
    game_id: "3800084",
    plan: "A",
  },
  {
    game_name: "※锈刀专属神器",
    ip: "█185版散人服",
    type: "8月10日/11点开放",
    line: "专属神器",
    detail: "█专属神器装备回收冲",
    qq: "经典沉默专属〃",
    game_id: "3800098",
    plan: "A",
  },
  {
    game_name: "朱砂复古沉默〃",
    ip: "沉默专属追梦服〃",
    type: "8月10日/11点开放",
    line: "智能挂机▃",
    detail: "智能挂机神宠助战货币可打散人服",
    qq: "经典沉默专属〃",
    game_id: "3800079",
    plan: "A",
  },
  {
    game_name: "断猿沉默专属▃",
    ip: "※沉默专属",
    type: "8月10日/11点开放",
    line: "切割狂暴追梦服★",
    detail: "切割狂暴专◆属神器打金服",
    qq: "沉默专属散人服",
    game_id: "3800063",
    plan: "A",
  },
  {
    game_name: "血池火龙三职业",
    ip: "█火龙专属爽",
    type: "8月10日/11点开放",
    line: "▁全新装备靠打",
    detail: "▁装备靠打新区连开多图打宝刚开服",
    qq: "灬火龙打宝",
    game_id: "3800067",
    plan: "A",
  },
  {
    game_name: "▁邪瞳无限刀▃",
    ip: "※无限刀版爆",
    type: "8月10日/11点开放",
    line: "※长久神宠助战",
    detail: "▁神宠助战泡点升级切割狂暴散人服",
    qq: "※神器追梦",
    game_id: "3800073",
    plan: "A",
  },
  {
    game_name: "█展锋飞羽沉默",
    ip: "沉默三职玩法",
    type: "8月10日/11点开放",
    line: "※新区连开",
    detail: "█新区连开泡点升级爽",
    qq: "经典沉默专属〃",
    game_id: "3800051",
    plan: "A",
  },
  {
    game_name: "墨杀神器单职业",
    ip: "▲新神器专属◆",
    type: "8月10日/11点开放",
    line: "灬装备保值区",
    detail: "装备保值长久耐玩首战区",
    qq: "灬神器追梦追梦服",
    game_id: "3800087",
    plan: "A",
  },
  {
    game_name: "锈刀微变三职业",
    ip: "长久经典复古★",
    type: "8月10日/11点开放",
    line: "◆职业·丰富",
    detail: "█职业丰富等级好升冲",
    qq: "复古怀旧散人服〃",
    game_id: "3800064",
    plan: "A",
  },
  {
    game_name: "━黄泉复古三职业★",
    ip: "176版稳╊",
    type: "8月10日/11点开放",
    line: "▁全新魔王高爆",
    detail: "灬魔王高爆多图打宝装备回收新区抢首战",
    qq: "复古◆怀旧",
    game_id: "3800071",
    plan: "A",
  },
  {
    game_name: "2003记忆传奇",
    ip: "爆特色传奇",
    type: "8月10日/11点开放",
    line: "※特色玩法可搬砖",
    detail: "灬特色玩法经典耐玩热血开荒新区抢首战",
    qq: "纯PC推散人首选",
    game_id: "111188",
    plan: "A",
  },
  {
    game_name: "残照迷◆失单职业",
    ip: "◆神器·专属",
    type: "8月10日/11点开放",
    line: "▲真长久耐玩◆",
    detail: "灬长久耐玩装备靠打等级好升散人来追梦",
    qq: "▁神器追梦",
    game_id: "3800055",
    plan: "A",
  },
  {
    game_name: "碧影王土无限刀",
    ip: "无限刀版★",
    type: "8月10日/11点开放",
    line: "灬新区连开散人服",
    detail: "灬新区连开上线领礼多图打宝骨灰来开荒",
    qq: "攻速推荐区〃",
    game_id: "3800061",
    plan: "A",
  },
  {
    game_name: "灬酒庐复古大陆",
    ip: "长久经典复古▃",
    type: "8月10日/11点开放",
    line: "装备靠打散人首选",
    detail: "装备靠打无◆坑公平散人服",
    qq: "复古怀旧可搬砖▃",
    game_id: "3800107",
    plan: "A",
  },
];
